import { createFileRoute } from '@tanstack/react-router';

import { BookingConfirmationPage } from '@/features/bookingConfirmation/BookingConfirmationPage';

export const Route = createFileRoute('/$missionId/booking-summary')({
	component: BookingSummaryRoute,
});

function BookingSummaryRoute() {
	const { missionId } = Route.useParams();
	return <BookingConfirmationPage missionId={missionId} />;
}
